import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Type from "./type";

export const getOfficeGroupListSaga = createAction(
  "GET_OFFICE_GROUP",
  ({ payload, params }: SagaActionParams<Type.OfficeGroupDto[]>) => ({
    payload,
    url: "/api/admin/officegroups" + (params ? params : ""),
  })
);
export const getOfficeGroupDetailsSaga = createAction(
  "GET_OFFICE_GROUP_DETAILS",
  ({ payload, id }: SagaActionParams<Type.OfficeGroupDetailDto>) => ({
    payload,
    url: "/api/admin/officegroups/" + id,
  })
);
export const createOfficeGroupSaga = createAction(
  "CREATE_OFFICE_GROUP",
  ({ payload, body }: SagaActionParams<Type.OfficeGroupDto>) => ({
    payload,
    url: "/api/admin/officegroups",
    body,
  })
);
export const updateOfficeGroupSaga = createAction(
  "UPDATE_OFFICE_GROUP",
  ({ payload, id, body }: SagaActionParams<Type.OfficeGroupDto>) => ({
    payload,
    url: "/api/admin/officegroups/" + id,
    body,
  })
);
export const deleteOfficeGroupSaga = createAction(
  "DELETE_OFFICE_GROUP",
  ({ payload, id }: SagaActionParams<Type.OfficeGroupDto>) => ({
    payload,
    url: "/api/admin/officegroups/" + id,
  })
);

const officegroupsSaga = [
  takeLatest<any>(
    getOfficeGroupListSaga.toString(),
    (payload: SagaGenericParams<Type.OfficeGroupDto[]>) =>
      getSaga<Type.OfficeGroupDto[]>(payload)
  ),
  takeLatest<any>(
    getOfficeGroupDetailsSaga.toString(),
    (payload: SagaGenericParams<Type.OfficeGroupDetailDto>) =>
      getSaga<Type.OfficeGroupDetailDto>(payload)
  ),
  takeLatest<any>(
    createOfficeGroupSaga.toString(),
    (payload: SagaGenericParams<Type.OfficeGroupDto>) =>
      postSaga<Type.OfficeGroupDto>(payload)
  ),
  takeLatest<any>(
    updateOfficeGroupSaga.toString(),
    (payload: SagaGenericParams<Type.OfficeGroupDto>) =>
      putSaga<Type.OfficeGroupDto>(payload)
  ),
  takeLatest<any>(
    deleteOfficeGroupSaga.toString(),
    (payload: SagaGenericParams<any>) =>
      deleteSaga<Type.OfficeGroupDto>(payload)
  ),
];

export default officegroupsSaga;
